// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navResponsive } from '../actions/actions';
import App from 'grommet/components/App';
import Split from 'grommet/components/Split';
import NavSidebar from './NavSidebar';
import Box from 'grommet/components/Box';
// import Toast from 'grommet/components/Toast';
// import Layer from 'grommet/layer/Layer';

import Sidebar from 'grommet/components/Sidebar';
import Layer from 'grommet/components/Layer';
import Button from 'grommet/components/Button';
import MenuIcon from 'grommet/components/icons/base/Menu';

const loaderStyle = {
  position: 'fixed',
  background: 'rgba(81, 91, 69, 0.98)',
  width: '100%',
  height: '100%',
  top: 0,
  zIndex: 9999
}

const imageStyle = {
  top: '50%',
  left: '50%',
  position: 'absolute',
  width: '3%'
}
class Main extends Component {

  constructor() {
    super();
    this._onResponsive = this._onResponsive.bind(this);
    this._showLoader = this._showLoader.bind(this);
    this.state = {
      multiple: true,
      showLayer: false
    };
  }

  _onResponsive(responsive) {
    if (responsive === 'single') {
      this.setState({ multiple: false });
    } else {
      this.setState({ multiple: true, showLayer: false });  
    }
    this.props.dispatch(navResponsive(responsive));
  }
  _showLoader() {
    if (this.props.showLoader) {
      return (<div style={loaderStyle}>
          <div>
            <img style={imageStyle} src="/img/loader.gif" alt="" />
          </div>
        </div>);
    } else {
      return null;
    }

  }

  render() {
        // console.log('ferret load:::', this.props)
    const {
      nav: { active: navActive, enabled: navEnabled, responsive }
    } = this.props;
    const includeNav = (navActive && navEnabled);
    let nav;

    const { multiple, showLayer }  = this.state;

    const content = (
      <NavSidebar />
    );
    let leftNode;
    let buttonNode;
    let layerNode;

    if (multiple && navEnabled) {
      leftNode = (
        <Sidebar colorIndex="neutral-1" fixed={true} className="left-menu">
          {content}
        </Sidebar>
      );   
    } else if (showLayer) {
      layerNode = (
        <Layer
          flush={true}
          colorIndex="neutral-1"
          fixed={true}
          className="left-menu"
          closer={true}
          onClose={() => this.setState({ showLayer: false })}
          peek={true}
        >
          {content}
        </Layer>
      );       
    } else if(responsive === 'single' && navEnabled) {
      buttonNode = (
        <Button icon={<MenuIcon />} style={{float: 'right'}} onClick={() => this.setState({ showLayer: true })} />  
      )
    }

    if (includeNav) {
      nav = <NavSidebar />;
    }
    const priority = (includeNav && 'single' === responsive ? 'left' : 'right');

    return (
      <App centered={false} className="main">
        <Split
          priority="right"
          flex="right" fixed={true}
          onResponsive={this._onResponsive}
        >
          {leftNode}
          {buttonNode}
          {this.props.children}
          {layerNode}
        </Split>
        {/*<Box full={true} colorIndex='light-2' alignSelf={start}>
        </Box>*/}
        {this._showLoader()}
      </App>
    );
  }
}

let select = (state) => ({
  nav: state.nav,
  showLoader: state.status.showLoader,
  session: state.session,
  // status: state.status
});

export default connect(select)(Main);



// WEBPACK FOOTER //
// ./src/js/components/Main.js